import { render, staticRenderFns } from "./MaisBuscados.vue?vue&type=template&id=fcbf16ca&"
import script from "./MaisBuscados.js?vue&type=script&lang=js&"
export * from "./MaisBuscados.js?vue&type=script&lang=js&"
import style0 from "./MaisBuscados.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
